import React from 'react';
import { Navigate } from 'react-router-dom';
import { useClientAuth } from '../contexts/ClientAuthContext';

const ClientProtectedRoute = ({ children }) => {
  const { client, loading } = useClientAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p className="body-medium">Loading...</p>
      </div>
    );
  }

  if (!client) {
    return <Navigate to="/client-login" replace />;
  }

  return children;
};

export default ClientProtectedRoute;